import React, { useId } from 'react';
import { Check } from 'lucide-react';
import { cx } from './cx';

export interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: React.ReactNode;
  disabled?: boolean;
  id?: string;
  className?: string;
  /** Test hook, set on the native input. */
  'data-testid'?: string;
}

/** Checkbox with its label; the whole row is clickable. */
export default function Checkbox({ checked, onChange, label, disabled, id, className, 'data-testid': testId }: CheckboxProps) {
  const autoId = useId();
  const inputId = id ?? autoId;
  return (
    <label htmlFor={inputId} className={cx('inline-flex items-start gap-3 font-ui text-body text-primary', disabled ? 'cursor-not-allowed text-disabled' : 'cursor-pointer', className)}>
      <input
        id={inputId}
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
        className="peer sr-only"
        data-testid={testId}
      />
      <span
        aria-hidden
        className={cx(
          'mt-0.5 inline-flex size-5 shrink-0 items-center justify-center rounded-[0.375rem] border transition-colors',
          'peer-focus-visible:ring-2 peer-focus-visible:ring-focus',
          checked ? 'border-transparent bg-action-primary text-white' : 'border-edge-strong bg-inset text-transparent'
        )}
      >
        <Check className="size-3.5" strokeWidth={3} />
      </span>
      <span className="min-w-0">{label}</span>
    </label>
  );
}
